export default "__VITE_ASSET__ChHs3qzB__"